export enum ErrorCode {
  LMS_GROUP_ALREADY_LINKED = "LMS_GROUP_ALREADY_LINKED",
  LEGAL_ENTITY_HAS_LINKED_RESOURCES = "LEGAL_ENTITY_HAS_LINKED_RESOURCES",
  /** Orders' 400 on POST /bookings and /projects/confirm-project when the attendees exceed the seats left. */
  SESSION_FULL = "SESSION_FULL",
  /** Orders' 400 when a step spans several days on a session synced with Docebo, whose events last one day. */
  MULTI_DAY_TIMESLOT_NOT_ALLOWED = "MULTI_DAY_TIMESLOT_NOT_ALLOWED",
}
